import * as React from "react";

import "./map-section.scss";

import {UseState}         from "@Common/react/use-state";
import {cs}               from "@Common/react/chain-services";
import {BubbleNoti}       from "@Common/ui-components/bubble-noti/bubble-noti";

import {HomeownersMapControl} from "./homeowners-map-control/homeowners-map-control";

export const MapSection = ({zipCodes, viewSize, next: rootNext}) => cs(
    ["hoveredShape", (_, next) => UseState({
        next,
    })],
    ["noti", (_, next) => BubbleNoti({next})],
    ({hoveredShape, noti}) => rootNext({
        renderErrorNoti: ({msg, color}) => noti.show({
            message: msg,
            color,
            duration: 10000,
        }),
        render: () => (
            <div className="map-section-r2t">
                {HomeownersMapControl({
                    center: [37, -111],
                    hoveredShape,
                    shapes: zipCodes?.map((zip) => ({
                        name: zip.zipCode,
                        elementKey: zip.zipCode,
                        count: zip.count,
                        color: !!zip.count ? "#249AF3" : "#99A0A7",
                        vertexList: zip.polygon,
                        opacity: .1 + (hoveredShape.value === zip.zipCode && .1) + (!zip.count && .2),
                        onMouseOver: () => hoveredShape.onChange(zip.zipCode),
                        onMouseOut : () => hoveredShape.onChange(null),
                    })),
                    pills: zipCodes?.map((zip) => ({
                        elementKey: zip.zipCode + "pill",
                        count: zip.count,
                        position: zip.center,
                        onMouseOver: () => hoveredShape.onChange(zip.zipCode),
                        onMouseOut : () => hoveredShape.onChange(null),
                    })),
                    viewSize,
                })}
            </div>
        )
    })
);